$(document).ready(function() {
	//add scrolling to body, for top navigation animation
	//using css3 animations
	$(window).on("scroll", function() {
 		if( $(this).scrollTop() > 0 ) {
  			$("body").addClass("scrolling");
  		} else {
  			$("body").removeClass("scrolling");
  		}
	});
	
	//navigation links, also disclaimer links
	$(document).on("click", "#report-header .navigation a, a[href='#disclaimer']", function(event) {
		event.preventDefault();
		var y = $($(this).attr("href")).position().top - 98;
		 $("html, body").stop().animate({ scrollTop: y }, 2000);
		 return false;
	}); 
	
	$(document).on("click", "#navigation-mobile-button", function(event) {
		event.preventDefault();
		if($(".navigation").is(":visible")) {
			$(".navigation").addClass("mobile-hide");
		} else {
			$(".navigation").removeClass("mobile-hide");
		}
	});

	$(document).on("click", "#report-header .navigation a", function(event) {
		event.preventDefault();
		if($(".navigation").is(":visible")) {
			$(".navigation").addClass("mobile-hide");
		} else {
			$(".navigation").removeClass("mobile-hide");
		}
	});	
});


